// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { WishlistProvider } from './context/WishlistContext';
import { SearchProvider } from './context/SearchContext';
import { Toaster } from 'react-hot-toast';
import { useVisitorTracking } from './hooks/useVisitorTracking';

// Pages
import HomePage from './pages/HomePage';
import CartPage from './pages/CartPage';
import WishlistPage from './pages/WishlistPage';
import ProductDetailPage from './pages/ProductDetailPage';
import SearchResultsPage from './pages/SearchResultsPage';
import AdminPanel from './pages/AdminPanel';
import CampaignsPage from './pages/Campaignspage';
import AuthPage from './pages/AuthPage';
import AccountDashboard from './pages/AccountDashboard';

// Components
import CartSidebar from './components/CartSidebar';
import { ProtectedRoute } from './components/ProtectedRoute';
import CheckoutPage from './pages/CheckoutPage';
import OrdersPage from './pages/OrdersPage';
import OrderDetailPage from './pages/OrderDetailPage';
import ReviewsPage from './pages/ReviewsPage';
import ContactPage from './pages/ContactPage';
import FAQPage from './pages/FAQPage';
import ShippingPage from './pages/ShippingPage';
import ReturnsPage from './pages/ReturnsPage';
import PaymentPage from './pages/PaymentPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import CookiesPage from './pages/CookiesPage';
import AccountSettingsPage from './pages/AccountSettingsPage';
import ScrollToTop from './components/ScrollToTop';
import AboutPage from './pages/AboutPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentFailPage from './pages/PaymentFailPage';
import OrderTrackingPage from './pages/OrderTrackingPage';
import InvoiceTestPage from './pages/InvoiceTestPage';

// ✅ Visitor tracking'i içeren wrapper component
function AppContent() {
  useVisitorTracking(); // ✅ Artık Router içinde
  
  return (
    <>
      <ScrollToTop />
      
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 2000,
          style: {
            background: '#2B2B2B',
            color: '#fff',
            borderRadius: '12px',
          },
          success: {
            iconTheme: {
              primary: '#06ffa5',
              secondary: '#fff',
            },
          },
          error: {
            iconTheme: {
              primary: '#E5332A',
              secondary: '#fff',
            },
          },
        }}
      />
      
      <CartSidebar />
      
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/wishlist" element={<WishlistPage />} />
        <Route path="/product/:id" element={<ProductDetailPage />} />
        <Route path="/search" element={<SearchResultsPage />} />
        <Route path="/category/:categoryName" element={<SearchResultsPage />} />
        <Route path='/campaigns' element={<CampaignsPage />} />
        <Route path='/checkout' element={<CheckoutPage />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path='/orders/:orderId' element={<OrderDetailPage />} />
        <Route path='/reviews' element={<ReviewsPage /> } />
        <Route path='/contact' element={<ContactPage /> } />
        <Route path='/faq' element={<FAQPage /> } />
        <Route path='/shipping' element={<ShippingPage /> } />
        <Route path='/returns' element={<ReturnsPage /> } />
        <Route path='/payment' element={<PaymentPage /> } />
        <Route path='/privacy' element={<PrivacyPage /> } />
        <Route path='/terms' element={<TermsPage /> } />
        <Route path='/cookies' element={<CookiesPage /> } />
        <Route path='/account/settings' element={<AccountSettingsPage /> } />
        <Route path='/about' element={<AboutPage /> } />
        <Route path='/payment-success' element={<PaymentSuccessPage /> } />
        <Route path='/payment-fail' element={<PaymentFailPage /> } />
        <Route path='/order-tracking' element={<OrderTrackingPage /> } />
        <Route path='/invoice' element={<InvoiceTestPage /> } />
        
        {/* Authentication Routes */}
        <Route path="/account" element={<AuthPage />} />
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <AccountDashboard />
            </ProtectedRoute>
          } 
        />
        
        {/* Protected Admin Route */}
        <Route 
          path="/admin" 
          element={
            <ProtectedRoute adminOnly>
              <AdminPanel />
            </ProtectedRoute>
          } 
        />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <CartProvider>
        <WishlistProvider>
          <SearchProvider>
            {/* ✅ AppContent Router içinde */}
            <AppContent />
          </SearchProvider>
        </WishlistProvider>
      </CartProvider>
    </Router>
  );
}

export default App;